module.exports = __webpack_public_path__ + "media/sub3-6-2.6c4ac351.mp4";